// extracted by mini-css-extract-plugin
module.exports = {"box":"Tabs_box_2Ew9a","tabs":"Tabs_tabs_Qyqri","sort-type":"Tabs_sort-type_1IYa5","search":"Tabs_search_GGEuA","icon":"Tabs_icon_3PvmP"};